module.exports = __webpack_public_path__ + "img/website.28b34cee.svg";